import { render } from "./PaginationTextComponent.vue?vue&type=template&id=135fe91f"
import script from "./PaginationTextComponent.vue?vue&type=script&lang=js"
export * from "./PaginationTextComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/components/pagination/PaginationTextComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "135fe91f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('135fe91f', __exports__)) {
    api.reload('135fe91f', __exports__)
  }
  
  module.hot.accept("./PaginationTextComponent.vue?vue&type=template&id=135fe91f", () => {
    api.rerender('135fe91f', render)
  })

}


export default __exports__